var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dialogs"},_vm._l((_vm.dialogs),function(dialog){return _c('Dialog',{key:dialog.id,attrs:{"dialog":dialog,"active-dialog":_vm.activeDialog},on:{"setDialog":function($event){return _vm.setDialog(dialog.id)}}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }